import { RNG } from "rot-js";
import { Actor } from "../actors/Actor";
import { getRampValue } from "../actors/Ramp";

const LETTER_SET = {
  A: 14,
  B: 2,
  C: 2,
  D: 4,
  E: 16,
  F: 2,
  G: 3,
  H: 2,
  I: 8,
  J: 1,
  K: 1,
  L: 4,
  M: 2,
  N: 9,
  O: 8,
  P: 2,
  Q: 0,
  R: 9,
  S: 4,
  T: 6,
  U: 4,
  V: 2,
  W: 2,
  X: 1,
  Y: 2,
  Z: 1,
};

export const LETTER_POOL = Object.entries(LETTER_SET).reduce(
  (result, [key, count]) => {
    for (let i = 0; i < count; i++) {
      result.push(key);
    }
    return result;
  },
  [] as string[]
);

export const fillWithLetters = (actor: Actor, max: number) => {
  for (let i = actor.spellWand.length; i < max; i++) {
    actor.spellWand.push(RNG.getItem(LETTER_POOL) || "");
  }
};

export const addLetters = (actor: Actor, count: number) => {
  const amount = Math.min(actor.maxLetters + 1, count + actor.spellWand.length);
  for (let j = actor.spellWand.length; j < amount; j++) {
    actor.spellWand.push(RNG.getItem(LETTER_POOL) || "");
  }
};
